import { modalAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(modalAnatomy.keys);

const baseStyle = definePartsStyle({
  dialog: {
    bg: "bg.container",
    border: "1px solid",
    borderColor: "border.container",
    boxShadow: "lg",
  },

  overlay: {
    bg: "dialog.backdrop",
  },
});

export const Modal = defineMultiStyleConfig({
  baseStyle,
});
